module.exports = __webpack_public_path__ + "assets/wh.1776c9ba.svg";